import { Button, StickyBarContent, StickyBarWrapper } from '@common/components';
import { useTranslations } from '@lang';
import { FC } from 'react';
import { Discount, Price } from 'shared-types/Common';

type SpaEntityStickyBarProps = {
  displayedPrice: Price;
  discountedPrice: Discount | undefined;
  id: string;
  isModalOpen: boolean;
  name: string | JSX.Element;
  onSubmit: () => void;
  displayPriceRangeIndicator: boolean;
};

export const SpaEntityStickyBar: FC<SpaEntityStickyBarProps> = ({
  displayedPrice,
  id,
  isModalOpen = false,
  name,
  onSubmit,
  displayPriceRangeIndicator,
  discountedPrice,
}) => {
  const { t } = useTranslations();
  return (
    <StickyBarWrapper id={id} zIndex={isModalOpen ? 9999 : undefined}>
      {!isModalOpen && (
        <StickyBarContent
          name={name}
          displayedPrice={displayedPrice}
          discountedPrice={discountedPrice}
          displayPriceRangeIndicator={displayPriceRangeIndicator}
          button={
            <Button
              isPrimary
              onClick={onSubmit}
              type="button"
              ariaLabel={`${t('spa.book')} - ${name}`}
            >
              {t('spa.book')}
            </Button>
          }
        />
      )}
    </StickyBarWrapper>
  );
};
